export default __webpack_public_path__ + "static/media/2.666af328.png";